import withStyles from "@material-ui/core/styles/withStyles";
import Checkbox from "@material-ui/core/Checkbox";
import React from "react";

export default withStyles({
    root: {
        marginRight: 5,
        '&$checked': {
            color: '#e8b32e',
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);
